<app-patient-header [member]="member" [showHeader]="showHeader" [type]="'patient'"></app-patient-header>
<app-flag-list [caseId]="" [memberId]="id"
    *ngIf="member !== undefined && member !== null && member.memberMergeHistory === null">
</app-flag-list>
<kendo-splitter #splitter *ngIf="member !== undefined && member !== null && member.memberMergeHistory === null"
    orientation="horizontal" style="background-color:#f5f6fb; border: none;" (layoutChange)="updateSplitterBar()">
    <kendo-splitter-pane>
        <kendo-tabstrip #summaryTabstrip (tabSelect)="onTabSelect($event)">
            <kendo-tabstrip-tab title="{{ 'SUMMARY' | translate }}" [selected]="true">
                <ng-template kendoTabContent>
                    <div class="content-background w-100 pt-0 pr-3 pl-3">
                        <app-patient-summary-chart [memberId]="id" *ngIf="communityEnabled && wellbeingEnabled">
                        </app-patient-summary-chart>
                        <div class="row" *ngIf="referralsEnabled">
                            <div class="col-sm-12">
                                <hr>
                                <app-case-list-detail [referralsOnly]="true" [patientSummary]="true"
                                    *ngIf="referralsEnabled && id" [caseId]="" [memberId]="id"
                                    (referralsOpenStateChanged)="referralsOpenStateChanged($event)">
                                </app-case-list-detail>
                            </div>
                        </div>
                        <div class="row w-100" *ngIf="referralsEnabled && !referralsCollapsed">
                            <div class="col-12 p-0 ml-3 mb-2 mt-2">
                                <button *ngIf="addReferralsEnabled" kendoButton [primary]="false" type="button"
                                    (click)="newReferral()" class="float-right mt-2">{{'NEW-REFERRAL' | translate}}<i
                                        class="far fa-plus"></i>
                                </button>
                                <button *ngIf="hasExternalSearchSources && mrnStrategy === 'PIX'" kendoButton
                                    [primary]="false" type="button" (click)="getReferralHistory()"
                                    class="float-right mr-3 mt-2">{{'UPDATE-REFERRAL-HISTORY' | translate}}
                                </button>
                            </div>
                        </div>
                        <app-member-assessment [memberId]="id" (refresh)="getMemberCountTabs()">
                        </app-member-assessment>
                        <app-case-member [memberId]="id"></app-case-member>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab class="p-0">
                <ng-template kendoTabTitle>
                    {{ 'HISTORY' | translate }}
                </ng-template>
                <ng-template kendoTabContent>
                    <div class="content-background w-100 pt-0 pr-3 pl-3"
                        *ngIf="member !== undefined && member !== null">
                        <div class="pt-2">
                            <button *ngIf="clinicalSummaryEnabled && member?.mrn && showClinicalSummary"
                                id="btnOpenClinicalViewer"
                                class="btn btn-outline-dark custom-button border border-secondary text-uppercase ml-2"
                                style="position: relative; float: right; top: -6px;" (click)="openClinicalViewer()">
                                {{'CLINICAL-SUMMARY' | translate}}&nbsp;<i class="fas fa-external-link"></i>
                            </button>
                            <button *ngIf="documentQueryEnabled && member?.mrn" id="btnQueryDocuments"
                                [disabled]="documentQueryInProgress"
                                class="btn btn-outline-dark custom-button border border-secondary text-uppercase ml-2"
                                style="position: relative; float: right; top: -6px;"
                                (click)="queryForDocuments(member.id)"
                                title="{{'CLINICAL-RECORD-SEARCH-HINT' | translate}}">
                                {{'CLINICAL-RECORD-SEARCH' | translate}}&nbsp;
                                <i style="width:20px" [ngClass]="{
                                    'k-icon k-i-loading': documentQueryInProgress, 
                                    'fas fa-file-search': !documentQueryInProgress }">
                                </i>
                            </button>
                            <button *ngIf="fhrViewEnabled" id="btnSwitchEHRView"
                                class="btn btn-outline-dark custom-button border border-secondary text-uppercase ml-2"
                                style="position: relative; float: right; top: -6px;" (click)="openEHRView()">
                                {{'EHR-VIEW' | translate}}&nbsp;<i class="fas fa-laptop-medical"></i>
                            </button>
                        </div>
                        <div class="content-background pl-0 pr-0 pt-0 w-100"
                            style="overflow:hidden; margin-right: 15px;">
                            <div class="row">
                                <div class="col-sm-12">
                                    <kendo-tabstrip #historyTabstrip style="background-color: #f5f6fb;"
                                        [scrollable]="false">
                                        <kendo-tabstrip-tab [selected]="true">
                                            <ng-template kendoTabTitle>
                                                {{ 'CASES' | translate }}
                                                <span *ngIf="tabCounts?.cases > 0"
                                                    class="badge badge-pill badge-counts">{{tabCounts?.cases}}</span>
                                            </ng-template>
                                            <ng-template kendoTabContent>
                                                <!-- Cases -->
                                                <div class="row mt-2">
                                                    <app-case-list-detail [referralsOnly]="false" [caseId]="0"
                                                        [memberId]="id">
                                                    </app-case-list-detail>
                                                </div>
                                            </ng-template>
                                        </kendo-tabstrip-tab>
                                        <kendo-tabstrip-tab>
                                            <ng-template kendoTabTitle>
                                                {{ 'TASKS' | translate }}
                                                <span *ngIf="tabCounts?.tasks > 0"
                                                    class="badge badge-pill badge-counts">{{tabCounts?.tasks}}</span>
                                            </ng-template>
                                            <ng-template kendoTabContent>
                                                <!-- Tasks -->
                                                <div class="row mt-2">
                                                    <app-task-list-detail [memberId]="id" [caseId]="0"
                                                        (refresh)="refreshAll(8500)">
                                                    </app-task-list-detail>
                                                </div>
                                            </ng-template>
                                        </kendo-tabstrip-tab>
                                        <kendo-tabstrip-tab *ngIf="contactsEnabled">
                                            <ng-template kendoTabTitle>
                                                <div kendoTooltip position="bottom" class="keyboard-accessible" tabindex="0" showOn="hover" style="display: inline;">
                                                    <span [title]="tabCounts?.contacts > 0 ? limitContactsText : ''">
                                                        {{ 'CONTACT-HISTORY' | translate }}
                                                        <span *ngIf="tabCounts?.contacts > 0"
                                                            class="badge badge-pill badge-counts">{{tabCounts?.contacts}}</span>
                                                    </span>
                                                </div>
                                            </ng-template>
                                            <ng-template kendoTabContent>
                                                <!-- Contact History -->
                                                <div class="row mt-2">
                                                    <div class="col-sm-12 pl-0 pr-0">
                                                        <app-contact-history-section [memberId]="id"
                                                            (refresh)="getMemberCountTabs()">
                                                        </app-contact-history-section>
                                                    </div>
                                                </div>
                                            </ng-template>
                                        </kendo-tabstrip-tab>
                                        <kendo-tabstrip-tab *ngIf="attachmentsEnabled">
                                            <ng-template kendoTabTitle>
                                                <div kendoTooltip position="bottom" class="keyboard-accessible" tabindex="0" showOn="hover" style="display: inline;">
                                                    <span [title]="tabCounts?.documents > 0 ? limitAttachmentsText : ''">
                                                        {{ 'DOCUMENTS' | translate }}
                                                        <span *ngIf="tabCounts?.documents > 0"
                                                            class="badge badge-pill badge-counts">{{tabCounts?.documents}}</span>
                                                    </span>
                                                </div>
                                            </ng-template>
                                            <ng-template kendoTabContent>
                                                <!-- Documents -->
                                                <div class="row mt-2">
                                                    <app-document [memberId]="id" [member]="member" [caseId]=""
                                                        [taskId]="" [taskDefinitionId]="" [messageId]="" [bpmId]=""
                                                        [allowSendCaptureLink]="true"
                                                        (uploadedDocument)="getMemberCountTabs()"
                                                        (deletedDocument)="getMemberCountTabs()">
                                                    </app-document>
                                                </div>
                                            </ng-template>
                                        </kendo-tabstrip-tab>
                                        <kendo-tabstrip-tab *ngIf="messagesEnabled">
                                            <ng-template kendoTabTitle>
                                                <div kendoTooltip position="bottom" class="keyboard-accessible" tabindex="0" showOn="hover" style="display: inline;">
                                                    <span [title]="tabCounts?.messages > 0 ? limitMessagesText : ''">
                                                        {{ 'MESSAGES' | translate }}
                                                        <span *ngIf="tabCounts?.messages > 0"
                                                            class="badge badge-pill badge-counts">{{tabCounts?.messages}}</span>
                                                    </span>
                                                </div>
                                            </ng-template>
                                            <ng-template kendoTabContent>
                                                <!-- Messages -->
                                                <div class="row mt-2">
                                                    <app-message-list-section [memberId]="id"
                                                        (refresh)="getMemberCountTabs()">
                                                    </app-message-list-section>
                                                </div>
                                            </ng-template>
                                        </kendo-tabstrip-tab>
                                        <kendo-tabstrip-tab *ngIf="notesEnabled">
                                            <ng-template kendoTabTitle>
                                                <div kendoTooltip position="bottom" class="keyboard-accessible" tabindex="0" showOn="hover" style="display: inline;">
                                                    <span [title]="tabCounts?.notes > 0 ? limitNotesText : ''">
                                                        {{ 'NOTES' | translate }}
                                                        <span *ngIf="tabCounts?.notes > 0"
                                                            class="badge badge-pill badge-counts">{{tabCounts?.notes}}</span>
                                                    </span>
                                                </div>
                                            </ng-template>
                                            <ng-template kendoTabContent>
                                                <!-- Notes -->
                                                <div class="row mt-2">
                                                    <app-notes-list-section [memberId]="id"
                                                        (refresh)="getMemberCountTabs()">
                                                    </app-notes-list-section>
                                                </div>
                                            </ng-template>
                                        </kendo-tabstrip-tab>
                                        <kendo-tabstrip-tab *ngIf="appointmentsEnabled">
                                            <ng-template kendoTabTitle>
                                                <div kendoTooltip position="bottom" class="keyboard-accessible" tabindex="0" showOn="hover" style="display: inline;">
                                                    <span [title]="tabCounts?.appointments > 0 ? limitAppointmentsText : ''">
                                                        {{ 'APPOINTMENTS' | translate }}
                                                        <span *ngIf="tabCounts?.appointments > 0"
                                                            class="badge badge-pill badge-counts">{{tabCounts?.appointments}}</span>
                                                    </span>
                                                </div>
                                            </ng-template>
                                            <ng-template kendoTabContent>
                                                <!-- Appointments -->
                                                <div class="row mt-2">
                                                    <app-appointment-list-section [memberId]="id"
                                                        (refresh)="getMemberCountTabs()">
                                                    </app-appointment-list-section>
                                                </div>
                                            </ng-template>
                                        </kendo-tabstrip-tab>
                                        <kendo-tabstrip-tab *ngIf="documentQueryEnabled && member?.mrn">
                                            <ng-template kendoTabTitle>
                                                {{ 'CLINICAL-RECORDS' | translate }}
                                                <span *ngIf="tabCounts?.clinicalRecords > 0"
                                                    class="badge badge-pill badge-counts">{{tabCounts?.clinicalRecords}}</span>
                                            </ng-template>
                                            <ng-template kendoTabContent>
                                                <!-- Clinical Records -->
                                                <div class="row mt-2">
                                                    <app-clinical-record-list [memberId]="id"
                                                        (refresh)="getMemberCountTabs()">
                                                    </app-clinical-record-list>
                                                </div>
                                            </ng-template>
                                        </kendo-tabstrip-tab>
                                    </kendo-tabstrip>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab title="{{ 'AUDIT' | translate }}" *ngIf="auditMemberEnabled">
                <ng-template kendoTabContent>
                    <div class="content-background pt-0">
                        <app-audit-member-list [enableAdvanced]="enableAdvanced" [memberId]="id">
                        </app-audit-member-list>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab *ngIf="member && member.hasAccumulators" title="{{ 'ACCUMULATORS' | translate }}">
                <ng-template kendoTabContent>
                    <app-patient-accumulator [memberId]="id"></app-patient-accumulator>
                </ng-template>
            </kendo-tabstrip-tab>
        </kendo-tabstrip>
    </kendo-splitter-pane>
    <kendo-splitter-pane
        *ngIf="(eventsEnabled || patientCareTeamsEnabled || (communityEnabled && pinnedResourcesEnabled)) && this.tabSelected < 2"
        [(size)]="rightPaneSize" [collapsible]="true" min="420px" [resizable]="true" style="overflow-x: hidden;">
        <div class="content-background p-30 pt-0">
            <div *ngIf="tabSelected === 0">
                <div *ngIf="eventsEnabled">
                    <hr>
                    <h6 class="text-uppercase collapsible-text" (click)="patientEventsCollapsible.toggleChange()">{{
                        'EVENTS' | translate}}&nbsp;
                        <span style="display: inline-flex">
                            <div kendoTooltip position="bottom" class="keyboard-accessible" tabindex="0" showOn="none"
                                aria-live="polite" (focus)="showTooltip(eventsTooltip)"
                                (mouseover)="showTooltip(eventsTooltip)" (blur)="hideTooltip()"
                                (mouseout)="hideTooltip()">
                                <a #eventsTooltip title="{{limitEventsText}}"><i
                                        class="fa fa-info-circle pointer"></i></a>
                            </div>
                        </span>
                        <app-collapsible #patientEventsCollapsible [storageKey]="'patient-events'"
                            (collapsibleToggle)="patientEventsCollapsed=$event">
                        </app-collapsible>
                    </h6>
                    <div *ngIf="!patientEventsCollapsed" class="overflow-section-event">
                        <app-event-list [memberId]="id" [source]="'patientSummary'"></app-event-list>
                    </div>
                </div>
                <div class="mt-4" *ngIf="patientCareTeamsEnabled">
                    <div>
                        <app-team-list [caseId]="" [memberId]="id" (addTask)="initiateTask($event)">
                        </app-team-list>
                    </div>
                </div>
                <div class="mt-4" *ngIf="goalsEnabled">
                    <div>
                        <app-goal-list [memberId]="id"></app-goal-list>
                    </div>
                </div>
                <div class="mt-4" *ngIf="communityEnabled && pinnedResourcesEnabled && id && id > 0">
                    <hr>
                    <h6 class="text-uppercase collapsible-text" (click)="pinnedResourcesCollapsible.toggleChange()">{{
                        'PINNED-RESOURCES' | translate}}&nbsp;
                        <app-collapsible #pinnedResourcesCollapsible [storageKey]="'patient-pinned-resources'"
                            (collapsibleToggle)="patientPinnedResourcesCollapsed=$event">
                        </app-collapsible>
                    </h6>
                    <div *ngIf="!patientPinnedResourcesCollapsed">
                        <app-pinned-resource-list [memberId]="id"></app-pinned-resource-list>
                    </div>
                </div>
            </div>
            <div *ngIf="tabSelected === 1">
                <div>
                    <hr>
                    <h6 class="text-uppercase collapsible-text" (click)="patientHistoryCollapsible.toggleChange()">
                        {{'AUDIT-HISTORY' | translate}}
                        <app-collapsible #patientHistoryCollapsible [storageKey]="'patient-histories'"
                            (collapsibleToggle)="patientHistoriesCollapsed=$event">
                        </app-collapsible>
                    </h6>
                    <div class="overflow-section-audit history-container">
                        <app-patient-history *ngIf="!patientHistoriesCollapsed" [entries]="patientEvents"
                            (scrolled)="patientHistoryScrolled()">
                        </app-patient-history>
                    </div>
                </div>
            </div>
        </div>
    </kendo-splitter-pane>
</kendo-splitter>

<app-referral [context]="'summary'" *ngIf="member !== undefined && member !== null" [memberId]="id" #referral>
</app-referral>